<template>
    <prime-dialog
        :closable="props.closable"
        :draggable="false"
        :style="{ width: '50vw' }"
        class="generic-dialog"
        dismissable-mask
        header="Delta GPT Terms of Use"
        modal
        :visible="props.visible"
    >
        <insights-terms-content />
        <template #footer v-if="!props.closable">
            <div class="flex-row-with-gap">
                <prime-button label="Accept" @click="emit('accept')" />
                <prime-button label="Decline" @click="emit('decline')" />
            </div>
        </template>
    </prime-dialog>
</template>

<script setup lang="ts">
import PrimeDialog from 'primevue/dialog';
import PrimeButton from 'primevue/button';
import InsightsTermsContent from '@/components/deltaGpt/InsightsTermsContent.vue';

const props = defineProps<{
    closable?: boolean;
    visible: boolean;
}>();

const emit = defineEmits<{
    accept: [];
    decline: [];
}>();
</script>
